<div class="threepl-service-map full-height">
  <bz-button class="threepl-service-map-fit" variant="tertiary"
             appBringozIdGenerator="threepl-service-map-fit-button"
             [ariaLabel]="'Center Map' | translate"
             (clicked)="fitBounds()">
    <bz-icon [icon]="fitIcon"></bz-icon>
  </bz-button>

  <div class="threepl-service-map-options">
    <bz-switch appBringozIdGenerator="threepl-service-map-satellite-checkbox" size="sm"
               [checked]="satellite()" (checkedChange)="satellite.set($event)">
      {{ 'Satellite' | translate }}
    </bz-switch>
  </div>

  <google-map height="100%" width="100%" [center]="center" [zoom]="zoom" [options]="mapOptions()" (mapIdle)="onIdle()">
    @if (pickup(); as position) {
      <map-marker [position]="position" [options]="{icon: pickupIcon}"></map-marker>
    }
    @if (destination(); as position) {
      <map-marker [position]="position" [options]="{icon: dropoffIcon}"></map-marker>
    }
    @if (driver(); as position) {
      <map-marker [position]="position" [options]="driverOptions()"></map-marker>
    }
  </google-map>
</div>
